<div class="task-card" [class.completed-card]="cardData.ui.isCompleted" (click)="clickHandler(cardData)">
    <div class="task-card-content">
        <div class="task-card-header">
            <div class="title">
                {{cardData.title}}
            </div>
            <div class="task-card-actions">
                <img class="clickup-mark" *ngIf="cardData.source === 'clickup'"
                    src="assets/images/clickuplogo.png" alt="ClickUp task" />
                <mat-icon *ngIf="cardData.documentsCount" class="header-attachment">attach_file</mat-icon>
                <mat-icon class="more-icon">more_horiz</mat-icon>
            </div>
        </div>

        <div class="topic" *ngIf="cardData.description">
            {{cardData.description}}
        </div>
    </div>
    <div class="time-stamp" [class.urgent]="cardData.ui.isDueSoon" *ngIf="cardData.timeStamp">
        <mat-icon>event</mat-icon>
        {{cardData.timeStamp}}
    </div>
    <div class="task-card-divider" *ngIf="cardData.timeStamp" aria-hidden="true"></div>
    <div class="task-card-footer">
        <div class="assignee" *ngIf="cardData.ui.assignees.length"
            [matTooltip]="cardData.ui.assigneeTooltip"
            matTooltipPosition="above">
            <div class="assignee-stack">
                <button class="assignee-avatar-btn"
                    *ngFor="let assignee of cardData.ui.visibleAssignees; trackBy: trackByMemberId"
                    type="button"
                    (click)="assigneeClickHandler($event, assignee)"
                    [attr.aria-label]="'Open profile of ' + (assignee | memberFullName)">
                    <img *ngIf="assignee.avatarUrl" class="assignee-avatar assignee-avatar-img"
                        [appAvatarImage]="assignee.avatarUrl"
                        [src]="assignee.avatarUrl"
                        [alt]="assignee | memberFullName" />
                    <span *ngIf="!assignee.avatarUrl" class="assignee-avatar"
                        [style.background]="avatarColor(assignee)">
                        {{assignee | memberInitials}}
                    </span>
                </button>
                <span class="assignee-more" *ngIf="cardData.ui.extraAssigneeCount">
                    +{{cardData.ui.extraAssigneeCount}}
                </span>
            </div>
        </div>
        <div class="footer-meta">
            <span class="document-count" *ngIf="cardData.documentsCount">
                <mat-icon>attach_file</mat-icon>
                {{cardData.documentsCount}}
            </span>
            <div class="priority-chip" [ngClass]="cardData.ui.priorityClass">
                <span class="priority-dot"></span>
                {{cardData.ui.priorityLabel}}
            </div>
        </div>
    </div>
</div>
